import React, {useEffect, useState} from "react";
import {
    TextField,
    Button,
    Grid,
    MenuItem,
    Select,
    FormControl,
    InputLabel,
    FormHelperText,
    CardHeader,
    CardContent,
    CardActions,
} from "@mui/material";
import { useDispatch } from "react-redux";
import {Alert, DialogCard, Loader} from "../../../../../Components";
import { setModal } from "../../../../Common/App";
import {addPermission} from "../../Redux/Action";

export const AddPermissionModal = ({groupName, permissionsInGroup}) => {

    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const [message, setMessage] = useState("");
    const [status, setStatus] = useState("");

    const [data, setData] = useState({
        name: "",
        placeholder: "hrms.employee.view",
        label: "",
        type: "feature",
        group: "",
        description: "",
    });

    useEffect(() => {
        if (groupName) {
            let sample = '';
            if (permissionsInGroup && permissionsInGroup.length > 0) {
                sample = permissionsInGroup[0].name; // e.g., "hrms.workflow.menu"
            }

            // Remove the last dot segment
            const sampleTrimmed = sample.includes('.')
                ? sample.substring(0, sample.lastIndexOf('.'))
                : sample;

            setData((prevData) => {
                const prefilledName = !prevData.name?.trim() ? sampleTrimmed : prevData.name;
                return {
                    ...prevData,
                    group: groupName || "",
                    name: prefilledName,
                    placeholder: sample,
                };
            });
        }
    }, [groupName, permissionsInGroup]);


    const handleChange = (e) => {
        const { name, value } = e.target;

        setMessage("");
        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: "",
        }));

        setData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleSave = async () => {
        setIsLoading(true);
        await addPermission({ dispatch, data }).then((res) =>  {
            setIsLoading(false);
            if (res.success) {
                dispatch(setModal({ component: null, open: false }));
            }
            setErrors(res.errors);
            setMessage(res.message);
            setStatus(res.status);
        })
    };

    return (
        <DialogCard>
            <CardHeader
                title="Add Permission"
                subheader="Add a new permission request"
                avatar={<Loader isLoading={isLoading} color="primary" type="linear" />}
            />
            <CardContent>
                <Grid container spacing={2}>
                    {message && (
                        <Grid item xs={12}>
                            <Alert severity={status} duration={-1} showCloseButton={false}>{message}</Alert>
                        </Grid>
                    )}
                    <Grid item xs={12}>
                        <FormControl fullWidth error={!!errors?.type}>
                            <InputLabel id="type-select">Permission Type</InputLabel>
                            <Select
                                labelId="type-select"
                                name="type"
                                label="Permission Type"
                                value={data.type}
                                onChange={handleChange}
                                required
                                variant="outlined"
                            >
                                <MenuItem key={"feature"} value={"feature"}>Feature</MenuItem>
                                <MenuItem key={"menu"} value={"menu"}>Menu</MenuItem>

                            </Select>
                            <FormHelperText>{errors?.type}</FormHelperText>
                        </FormControl>
                    </Grid>

                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            label="Permission Name"
                            name="name"
                            placeholder={data.placeholder || "hrms.employee.view"}
                            value={data.name}
                            onChange={handleChange}
                            error={!!errors?.name}
                            helperText={errors?.name || data?.placeholder}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            label="Label"
                            name="label"
                            value={data.label}
                            onChange={handleChange}
                            onBlur={() => {
                                if (!data.description?.trim()) {
                                    setData(prev => ({ ...prev, description: data.label }));
                                }
                            }}
                            error={!!errors?.label}
                            helperText={errors?.label}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            label="Group"
                            name="group"
                            value={data.group}
                            onChange={handleChange}
                            error={!!errors?.group}
                            helperText={errors?.group}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            multiline
                            rows={3}
                            label="Description"
                            name="description"
                            value={data.description}
                            onChange={handleChange}
                            error={!!errors?.description}
                            helperText={errors?.description}
                        />
                    </Grid>

                </Grid>
            </CardContent>
            <CardActions>
                <Button
                    onClick={() => dispatch(setModal({ component: null, open: false }))}
                    variant="outlined"
                    color="secondary"
                >
                    Cancel
                </Button>

                <Button
                    onClick={handleSave}
                    disabled={isLoading}
                    variant="contained"
                    color="primary"
                >
                    Submit
                </Button>
            </CardActions>
        </DialogCard>
    );
};